"use client";

import { useEffect } from "react";
import { useSearchParams, usePathname, useRouter } from "next/navigation";
import { useUpgradeSuccessModal } from "../hooks/useUpgradeSuccessModal";
import { useUser } from "../hooks/useUser";
import { confirmCheckout } from "@/features/billing/lib/billingApi";

/**
 * When user lands on /?upgraded=pro|studio (after Creem checkout; legacy "1"
 * = pro), opens the tier-aware success modal, activates the plan from the
 * `checkout_id` Creem appends (so it doesn't wait for the webhook), refreshes
 * the plan, and cleans the URL.
 */
export function UpgradeSuccessFromUrl() {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();
  const { open } = useUpgradeSuccessModal();
  const { refresh } = useUser();

  useEffect(() => {
    if (pathname !== "/") return;
    const upgraded = searchParams.get("upgraded");
    if (!upgraded) return;

    open(upgraded === "studio" ? "studio" : "pro");
    const checkoutId = searchParams.get("checkout_id");
    // The modal polls refresh() until the plan reads upgraded; confirming
    // the checkout first usually makes the very first poll succeed.
    if (checkoutId) {
      confirmCheckout(checkoutId)
        .catch(() => null)
        .finally(() => void refresh());
    } else {
      void refresh();
    }
    router.replace("/", { scroll: false });
  }, [pathname, searchParams, open, refresh, router]);

  return null;
}
